module.exports = "/images/AM.png?84b0c956a224fb09f87b4acf7ddf31dc";